import useFeatureTags from "@custom-hooks/useFeatureTags";
import useUserAuth from "@custom-hooks/useUserAuth";
import isBlank from "@sedan-utils/is-blank";
import { getIt } from "@uikit/getIt";
import LoadingOutline from "@views/components/LoadingOutline";
import { HomeUsePluginRoot } from "@views/thinking-layout-editor/HomeUsePlugin";
import { FotAuthStore } from "imagica-corekit/dist/base/store/FotAuthStore";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { ReactFlowProvider } from "reactflow";
import { matchMobile } from "@uikit/func";
import { Cot } from "@uiview/pages/mobile/COT/Cot";

// const authStore = getIt(FotAuthStore);

export type EditorProps = {
  clickLogOut: () => void;
  page?: string;
  share?: boolean;
};

export function Editor(props: EditorProps) {
  const feature_tags = useFeatureTags();
  // const { getUserMe, userMeState } = useUserAuth();

  // const userMe = useSelector((state: any) => state.editor.me);

  const isMobile = matchMobile();

  // useEffect(() => {

  //   if ((isBlank(authStore.state.brainToken) === false || props.share !== true) && isBlank(userMe)) {
  //     getUserMe();
  //   } else {
  //     getUserMe("", true);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // if (userMeState.success === false) {
  //   return <LoadingOutline />;
  // }

  if (isMobile && feature_tags.disableMobilePage === false && props.share !== true) {
    return <Cot clickLogOut={props.clickLogOut} />;
  }

  return (
    <ReactFlowProvider>
      <HomeUsePluginRoot {...props} />
    </ReactFlowProvider>
  );
}
